var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.finalIcon !== null)?_c('v-icon',[_vm._v(_vm._s(_vm.finalIcon))]):_vm._e(),(_vm.finalText !== null)?_c('span',{class:{'ml-2': _vm.finalIcon !== null}},[_vm._v(_vm._s(_vm.finalText))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }